import { Shark, View } from "shark-mvc";

import templateContent from "./user-profile.html";

import mainNavComponent from "../../_shark_jaws/components/mainNavComponent";
import { userManager } from "../../_shark_jaws/managers/userManager";

class UserProfileView extends View {
	constructor() {
		super("userProfileView");

		this.setTemplate(templateContent);
	}

	cancelEditUserBtn_clickHandler () {
		Shark.set({
			currUser: Shark.get("currUserNotEdited"),
			isEditing: !Shark.get("isEditing"),
			__isEditing: !Shark.get("isEditing"),
		});
		Shark.render();
	}

	disablePushNotificationsBtn_clickHandler () {
		this.disablePushNotifications();
	}

	enablePushNotificationsBtn_clickHandler () {
		localStorage.removeItem("userPushSubscriptionDisabled");
		pushManager.registerIfYouCan();
	}

	editUserBtn_clickHandler () {
		Shark.set({
			currUserNotEdited: Shark.get("currUser"),
			isEditing: !Shark.get("isEditing"),
			__isEditing: !Shark.get("isEditing"),
		});
		Shark.render();
	}

	init () {
		this.addComponents([mainNavComponent]);
	}

	saveUserBtn_clickHandler () {
		const currUser = Shark.get("currUser");

		if (currUser.password !== "" && currUser.password === currUser.__passwordConfirm) {
			userManager.save(Shark.get("currUser"))
			.then(saveUserResponse => {
				console.log({saveUserResponse});
				Shark.set({
					isEditing: false,
					__isEditing: false,
				});
				Shark.render();
		
			});
		}
		else {
			this.set({
				__passwordError: true
			});
			Shark.render();
		}
	}

	userManager_userUpdateErrorHandler () {
		this.set({
			__updateError: true
		});
		Shark.render();
	}
}

const userProfileView = new UserProfileView();

Shark.registerView(userProfileView);

export default userProfileView;
